import { Injectable } from '@angular/core';
import { Vertex } from '../types';

@Injectable()
export class SvgHelper {

    public getPolyPoints(points: Vertex[]): string {
        return points.map(p => p.x.toString() + ' ' + p.y.toString()).join(' ');
    }
}
